import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "deal" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "hint"
}
const _hoisted_6 = { class: "grid2" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "field"
}
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  class: "hint top"
}
const _hoisted_13 = { class: "line-top" }
const _hoisted_14 = { class: "line-name" }
const _hoisted_15 = ["checked", "onChange"]
const _hoisted_16 = { class: "amount" }
const _hoisted_17 = {
  key: 0,
  class: "line-inputs"
}
const _hoisted_18 = {
  key: 0,
  class: "muted"
}
const _hoisted_19 = ["value", "onInput"]
const _hoisted_20 = ["value", "onInput"]
const _hoisted_21 = { class: "muted" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "totals" }
const _hoisted_24 = { class: "grand" }
const _hoisted_25 = {
  key: 1,
  class: "hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("label", null, [
        _createTextVNode("Product "),
        _createElementVNode("span", { class: "req" }, "*")
      ], -1)),
      _createElementVNode("select", {
        value: _ctx.modelValue.jahaji_product_id,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setProduct($event.target.value)))
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("option", { value: "" }, "Select", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (p) => {
          return (_openBlock(), _createElementBlock("option", {
            key: p.id,
            value: p.id
          }, _toDisplayString(p.name), 9, _hoisted_4))
        }), 128))
      ], 40, _hoisted_3),
      (_ctx.hint)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.hint), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.product)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", null, [
                _createTextVNode("Number of " + _toDisplayString(_ctx.unitWord) + "s ", 1),
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "req" }, "*", -1))
              ]),
              _createElementVNode("input", {
                type: "number",
                min: "1",
                value: _ctx.modelValue.units,
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.set('units', $event.target.value)))
              }, null, 40, _hoisted_8)
            ]),
            (_ctx.priced.hasRecurring)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", null, "Expected duration", -1)),
                  _createElementVNode("select", {
                    value: String(_ctx.modelValue.contract_months),
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.set('contract_months', $event.target.value)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthOptions, (m) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: m,
                        value: String(m)
                      }, _toDisplayString(m) + " month" + _toDisplayString(m > 1 ? 's' : ''), 9, _hoisted_11))
                    }), 128))
                  ], 40, _hoisted_10)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.priced.hasRecurring)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, "How long the client will probably keep using it. Recurring fees count for this many months."))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priced.lines, (line) => {
            return (_openBlock(), _createElementBlock("div", {
              key: line.charge.id,
              class: _normalizeClass(["line", { off: !line.included }])
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, [
                  (line.charge.is_optional)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "checkbox",
                        checked: line.included,
                        onChange: ($event: any) => (_ctx.setLine(line.charge.id, 'included', $event.target.checked))
                      }, null, 40, _hoisted_15))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(line.charge.name), 1)
                ]),
                _createElementVNode("span", _hoisted_16, _toDisplayString(line.included ? _ctx.money(line.amount) : '—'), 1)
              ]),
              (line.included)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (line.charge.per_unit)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(line.quantity) + " " + _toDisplayString(_ctx.unitWord) + _toDisplayString(line.quantity === 1 ? '' : 's') + " ×", 1))
                      : (_openBlock(), _createElementBlock("input", {
                          key: 1,
                          type: "number",
                          min: "1",
                          class: "qty",
                          value: line.quantity,
                          onInput: ($event: any) => (_ctx.setLine(line.charge.id, 'quantity', $event.target.value))
                        }, null, 40, _hoisted_19)),
                    _createElementVNode("input", {
                      type: "number",
                      min: "0",
                      step: "0.01",
                      class: "price",
                      value: line.unitPrice,
                      onInput: ($event: any) => (_ctx.setLine(line.charge.id, 'unit_price', $event.target.value))
                    }, null, 40, _hoisted_20),
                    _createElementVNode("span", _hoisted_21, [
                      _createTextVNode(_toDisplayString(line.charge.charge_type === 'recurring' ? 'per ' + _ctx.period(line.charge.billing_period) + ' × ' + line.periods : 'one-time'), 1),
                      (line.charge.vat_rate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, " · VAT " + _toDisplayString(line.charge.vat_rate) + "%", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128)),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", null, [
              _cache[7] || (_cache[7] = _createElementVNode("span", null, "Subtotal", -1)),
              _createElementVNode("b", null, _toDisplayString(_ctx.money(_ctx.priced.subtotal)), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[8] || (_cache[8] = _createElementVNode("span", null, "VAT", -1)),
              _createElementVNode("b", null, _toDisplayString(_ctx.money(_ctx.priced.vat)), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _cache[9] || (_cache[9] = _createElementVNode("span", null, "Total", -1)),
              _createElementVNode("b", null, _toDisplayString(_ctx.money(_ctx.priced.total)), 1)
            ])
          ]),
          (_ctx.product.event_charges.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, " Charged later when it happens: " + _toDisplayString(_ctx.product.event_charges.map(e => e.name + ' — ' + _ctx.money(e.default_price)).join('; ')), 1))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}